import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Hammer, Zap, Paintbrush, Wrench, Shield, Clock, Star } from 'lucide-react';

export default function Landing() {
  const navigate = useNavigate();

  const categories = [
    {
      name: 'Plomería',
      icon: Wrench,
      image: 'https://images.unsplash.com/photo-1733342797839-83a59e328324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxwbHVtYmVyJTIwZml4aW5nJTIwc2luayUyMHRvb2xzfGVufDB8fHx8MTc3MTAzNDY3OXww&ixlib=rb-4.1.0&q=85',
      value: 'plomeria'
    },
    {
      name: 'Electricidad',
      icon: Zap,
      image: 'https://images.unsplash.com/photo-1595856619767-ab739fa7daae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMGNoZWNraW5nJTIwd2lyZXN8ZW58MHx8fHwxNzcxMDM0NjgxfDA&ixlib=rb-4.1.0&q=85',
      value: 'electricidad'
    },
    {
      name: 'Pintura',
      icon: Paintbrush,
      image: 'https://images.unsplash.com/photo-1688372199140-cade7ae820fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxwYWludGVyJTIwcGFpbnRpbmclMjB3YWxsJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzcxMDM0NjgyfDA&ixlib=rb-4.1.0&q=85',
      value: 'pintura'
    },
    {
      name: 'Albañilería',
      icon: Hammer,
      image: 'https://images.unsplash.com/photo-1570894410457-adb47d89a36b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxtYXNvbiUyMGJyaWNrbGF5ZXIlMjB3b3JraW5nfGVufDB8fHx8MTc3MTAzNDY4N3ww&ixlib=rb-4.1.0&q=85',
      value: 'albanileria'
    },
    {
      name: 'Ingeniero Civil',
      icon: Hammer,
      image: 'https://images.unsplash.com/photo-1685233503586-0cb11f46e99f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxjaXZpbCUyMGVuZ2luZWVyJTIwY29uc3RydWN0aW9uJTIwc2l0ZSUyMGJsdWVwcmludHN8ZW58MHx8fHwxNzcxNDYyMjk1fDA&ixlib=rb-4.1.0&q=85',
      value: 'ingeniero_civil'
    },
    {
      name: 'Arquitecto',
      icon: Hammer,
      image: 'https://images.pexels.com/photos/4458210/pexels-photo-4458210.jpeg',
      value: 'arquitecto'
    },
    {
      name: 'Topografía',
      icon: Hammer,
      image: 'https://images.unsplash.com/photo-1654643353201-8123d31163db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHx0b3BvZ3JhcGhpYyUyMHN1cnZleWluZyUyMGxhbmQlMjBtZWFzdXJlbWVudHxlbnwwfHx8fDE3NzE0NjIyOTh8MA&ixlib=rb-4.1.0&q=85',
      value: 'topografia'
    },
    {
      name: 'Cerrajería',
      icon: Wrench,
      image: 'https://images.pexels.com/photos/792034/pexels-photo-792034.jpeg',
      value: 'cerrajeria'
    },
    {
      name: 'Planos y Diseños',
      icon: Paintbrush,
      image: 'https://images.pexels.com/photos/4458203/pexels-photo-4458203.jpeg',
      value: 'planos_disenos'
    },
    {
      name: 'Licencias',
      icon: Hammer,
      image: 'https://images.pexels.com/photos/48148/document-agreement-documents-sign-48148.jpeg',
      value: 'licencias'
    }
  ];

  const features = [
    { icon: Clock, title: 'Respuesta Inmediata', description: 'Encuentra trabajadores disponibles en minutos' },
    { icon: Shield, title: 'Profesionales Verificados', description: 'Todos nuestros trabajadores están calificados' },
    { icon: Star, title: 'Sistema de Calificaciones', description: 'Lee opiniones de otros clientes' }
  ];

  return (
    <div className="min-h-screen relative">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        {/* Logo as Full Background */}
        <div className="absolute inset-0">
          <img 
            src="https://customer-assets.emergentagent.com/job_emergencia-fix/artifacts/z3hbs9yd_1771467132164.png" 
            alt="Construclic Background" 
            className="w-full h-full object-cover opacity-20"
            style={{ filter: 'blur(8px) brightness(0.4)' }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#3A4F6C]/95 to-[#2A3B4F]/95"></div>
        </div>
        
        <div className="relative container mx-auto px-4 py-20">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-white mb-6" data-testid="hero-title">
              Constru<span className="text-[#FF8935]">/</span>clic
            </h1>
            <p className="text-xl sm:text-2xl text-slate-200 mb-8 font-medium">
              Conecta con trabajadores de construcción profesionales al instante
            </p>
            <p className="text-lg text-slate-300 mb-10 max-w-2xl mx-auto">
              Encuentra especialistas en plomería, electricidad, pintura y albañilería.
              Rápido, seguro y confiable.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center flex-wrap">
              <Button
                data-testid="cta-client-button"
                onClick={() => navigate('/auth?role=client')}
                className="bg-[#FF8935] hover:bg-[#E67A2E] text-white font-bold py-6 px-8 rounded-full text-lg shadow-lg"
                size="lg"
              >
                Buscar Trabajadores <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
              <Button
                data-testid="cta-worker-button"
                onClick={() => navigate('/auth?role=worker')}
                variant="outline"
                className="bg-white/10 border-2 border-white/30 hover:bg-white/20 text-white font-bold py-6 px-8 rounded-full text-lg backdrop-blur-sm"
                size="lg"
              >
                Soy Trabajador
              </Button>
              <Button
                data-testid="cta-affiliate-admin-button"
                onClick={() => navigate('/auth?role=affiliate_admin')}
                variant="outline"
                className="bg-white/10 border-2 border-[#FF8935]/60 hover:bg-[#FF8935]/20 text-white font-bold py-6 px-8 rounded-full text-lg backdrop-blur-sm"
                size="lg"
              >
                Soy Administrador
              </Button>
            </div>
            <p className="text-slate-300 text-sm mt-4 max-w-2xl mx-auto">
              💰 Como <strong className="text-[#FF8935]">Administrador Afiliado</strong> recibes un cashback del 5% en cada trabajo que solicites y se complete a través de la plataforma.
            </p>
          </div>
        </div>
      </div>

      {/* Categories Section */}
      <div className="bg-slate-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-4 text-slate-900" data-testid="categories-title">
            SERVICIOS DISPONIBLES
          </h2>
          <p className="text-center text-slate-600 mb-12 text-lg">
            Encuentra al profesional que necesitas
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 max-w-7xl mx-auto">
            {categories.map((category) => {
              const Icon = category.icon;
              return (
                <div
                  key={category.value}
                  data-testid={`category-${category.value}`}
                  className="group relative overflow-hidden rounded-xl bg-white border border-slate-200 shadow-sm hover:shadow-lg cursor-pointer"
                  onClick={() => navigate('/auth')}
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={category.image}
                      alt={category.name}
                      className="w-full h-full object-cover group-hover:scale-110"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/40 to-transparent flex flex-col justify-end p-6">
                    <Icon className="h-8 w-8 text-[#FF8935] mb-2" />
                    <h3 className="text-2xl font-bold text-white">{category.name}</h3>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="bg-white py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12 text-slate-900">
            ¿POR QUÉ CONSTRU/CLIC?
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  data-testid={`feature-${index}`}
                  className="text-center p-6 rounded-xl bg-slate-50 border border-slate-200 hover:border-[#FF8935]"
                >
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-[#FF8935] rounded-full mb-4">
                    <Icon className="h-8 w-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-slate-900">{feature.title}</h3>
                  <p className="text-slate-600">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* How It Works */}
      <div className="bg-slate-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12 text-slate-900">
            CÓMO FUNCIONA
          </h2>
          
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-[#FF8935] text-white rounded-full font-bold text-xl mb-4">
                  1
                </div>
                <h3 className="text-xl font-bold mb-2">Publica tu necesidad</h3>
                <p className="text-slate-600">Describe el trabajo que necesitas realizar</p>
              </div>
              
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-[#FF8935] text-white rounded-full font-bold text-xl mb-4">
                  2
                </div>
                <h3 className="text-xl font-bold mb-2">Recibe ofertas</h3>
                <p className="text-slate-600">Los trabajadores cercanos te contactan</p>
              </div>
              
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-[#FF8935] text-white rounded-full font-bold text-xl mb-4">
                  3
                </div>
                <h3 className="text-xl font-bold mb-2">¡Listo!</h3>
                <p className="text-slate-600">El trabajo se realiza y pagas de forma segura</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-[#FF8935] to-[#E67A2E] py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">
            ¿LISTO PARA COMENZAR?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Únete a miles de usuarios que ya confían en Constru/clic
          </p>
          <Button
            data-testid="footer-cta-button"
            onClick={() => navigate('/auth')}
            className="bg-white hover:bg-slate-100 text-[#FF8935] font-bold py-6 px-8 rounded-full text-lg shadow-xl"
            size="lg"
          >
            Comenzar Ahora <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-[#3A4F6C] py-8">
        <div className="container mx-auto px-4 text-center text-slate-300">
          <p>&copy; 2024 Constru/clic. Todos los derechos reservados.</p>
        </div>
      </div>
    </div>
  );
}